import { ENDPOINTS } from '@polyai/stream/endpoints';
import { CommandBatch } from '@polyai/stream/protobuf/commands';

import { doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type { CommandBatchResponse } from './types';

export const sendCommandBatch = ({
  batch,
  accountId,
  projectId,
  branchId,
}: {
  batch: CommandBatch;
  accountId: string;
  projectId: string;
  branchId: string;
}) => {
  return doPost<CommandBatchResponse>(
    generateNextPath(ENDPOINTS.BRANCH_COMMAND_BATCH, {
      accountId,
      projectId,
      branchId,
    }),
    LOGGER_TYPE.JUPITER,
    // TODO: When encoding medium sized messages (messages that include a variants csv to import)
    // the UI freezes and becomes unresponsive for 5-10 seconds.
    // One potential solution could be moving the message encoding to a web worker to avoid blocking the UI thread.
    CommandBatch.encode(batch).finish(),
    {
      postingFile: true,
      parseResponseToJSON: true,
      additionalHeaders: {
        'Content-Type': 'application/octet-stream',
      },
      prefix: 'sourcerer',
    },
  );
};
